export class LocalStorageConstants {
    static readonly token = 'token';
    static readonly xToken = 'x-token';
    static readonly apiKey = 'apiKey';
    static readonly currentUser = 'currentUser';
    static readonly userAuthorities = 'userAuthorities';
    static readonly theme = 'theme';
}
